import styled from '@emotion/styled';

export const OuterContainer = styled('div')({
    padding: '0px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: 'calc(92vh - 64px)',
});

export const LayoutRow = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    overflow: 'hidden',
});

export const SidebarColumn = styled('div')({
    width: '15%',
    height: '100%',
    overflowY: 'auto',
    flexShrink: 0,
});

export const MainContentColumn = styled('div')({
    width: '85%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flexShrink: 0,
    borderRadius: '10px',
    boxShadow: 'inset 0px 4px 10px rgba(0, 0, 0, 0.1)'
});

export const Box = styled('div')({
    width: 'auto',
    height: 'calc(92vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flexShrink: 0,
    borderRadius: '10px',
    boxShadow: 'inset 0px 4px 10px rgba(0, 0, 0, 0.1)'
});